const cliInvoiceStatus = {
  cli_inv_status: [
    {
      _id: 0,
      status: "Pending",
    },
    {
      _id: 1,
      status: "Sent Invoice",
    },
    {
      _id: 2,
      status: "Cancelled",
    },
    // {
    //   _id: 3,
    //   status: "Cancelled",
    // },
    {
      _id: 4,
      status: "Payment Processed",
    },
    {
      _id: 5,
      status: "Overdue",
    },
  ],
};
export default cliInvoiceStatus;
